import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, List, ListItem, ListItemText, ListItemButton, Chip, Box, Typography } from '@mui/material';
import accounts from '../constants/accounts.json';
import { getApiEnvironment as getApiEnv, setApiEnvironment as setApiEnv } from '../constants/api.constants';

interface EnvironmentSwitcherProps {
  open: boolean;
  onClose: () => void;
}


export const EnvironmentSwitcher: React.FC<EnvironmentSwitcherProps> = ({ open, onClose }) => {
  const [currentEnvironment, setCurrentEnvironment] = useState<string>(getApiEnv());

  const handleEnvironmentSelect = async (tag: string) => {
    setApiEnv(tag);
    setCurrentEnvironment(tag);
    
    // Reload the page to apply new environment
    window.location.reload();
  };

  const environments = Object.values(accounts)
    .filter((account): account is typeof account & { 'api-id': string } => 
      'api-id' in account && !!account['api-id']
    ) // Only show environments with API config
    .map(account => ({
      tag: account.tag,
      name: account.tag === 'equaliq' ? 'Production' : account.tag.replace('test-', '').charAt(0).toUpperCase() + account.tag.replace('test-', '').slice(1),
    }));

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Switch Environment</DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="textSecondary" sx={{ mb: 2 }}>
          Select a backend environment. The page will reload after switching.
        </Typography>
        
        <List>
          {environments.map((env) => (
            <ListItem key={env.tag} disablePadding>
              <ListItemButton 
                onClick={() => handleEnvironmentSelect(env.tag)}
                selected={currentEnvironment === env.tag}
              >
                <ListItemText 
                  primary={
                    <Box display="flex" alignItems="center" gap={1}>
                      <span style={{ textTransform: 'capitalize' }}>{env.name}</span>
                      {currentEnvironment === env.tag && (
                        <Chip label="Current" size="small" color="primary" />
                      )}
                    </Box>
                  }
                  secondary={env.tag}
                />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </DialogContent>
    </Dialog>
  );
};

export default EnvironmentSwitcher;